import { render, staticRenderFns } from "./SatisfactionPollsList.vue?vue&type=template&id=09598b52"
import script from "./SatisfactionPollsList.vue?vue&type=script&lang=js"
export * from "./SatisfactionPollsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports